module.exports = __webpack_public_path__ + "img/jch2.cb0c3577.jpg";